// extracted by mini-css-extract-plugin
module.exports = {"searchTextEditor":"AttributeSearch_searchTextEditor__1dsuo","searchRelativeDataEditor":"AttributeSearch_searchRelativeDataEditor__1yLoD"};